import Vue from 'vue'
import Router from 'vue-router'
import qs from 'qs'
import Main from './views/main.vue'
import Confirm from './views/confirm.vue'
import Done from './views/done'
import ErrorView from './views/error'
import store from './store'

Vue.use(Router)
window._qs = qs
export default new Router({
  mode: 'hash',
  stringifyQuery: query => {
    let s = qs.stringify(query)
    if (s) return '?' + s
    return ''
  },
  parseQuery: s => {
    if (s.startsWith('?')) s = s.substring(1)
    return qs.parse(s)
  },
  routes: [
    {
      path: '/',
      name: 'main',
      component: Main,
    },
    {
      path: '/confirm',
      name: 'confirm',
      component: Confirm,
    },
    {
      path: '/done',
      name: 'done',
      component: Done,
    },
    {
      path: '/auth',
      meta: {
        public: true,
      },
      async beforeEnter(to, from, next) {
        try {
          let token = to.query.token
          await store.dispatch('auth', token)
          console.log('go main')
          next({ name: 'main' })
        } catch (err) {
          console.error(err)
          console.log('hoge')
          next({ name: 'error' })
        }
      },
    },
    {
      path: '*',
      name: 'error',
      component: ErrorView,
      meta: {
        public: true,
      },
    },
  ],
})
